"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The Workflows service, is target to fetch workflow data.
 */
var Workflows = /*#__PURE__*/function (_Base) {
  /**
   * Create the Workflows service instance.
   *
   * @param sdk - the SDK instance
   */
  function Workflows(sdk) {
    (0, _classCallCheck2["default"])(this, Workflows);
    return _callSuper(this, Workflows, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Workflows, _Base);
  return (0, _createClass2["default"])(Workflows, [{
    key: "getTemplates",
    value: (
    /**
     * Get all workflow templates in target project.
     *
     * @param projectId - is the project id
     * @param config -  Configurable object for overwrite request parameters.
     * @returns array of template.
     */
    function () {
      var _getTemplates = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/templates");
              _context.next = 3;
              return this.HttpService.dmV2.get(url, config);
            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.data || []);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTemplates(_x, _x2) {
        return _getTemplates.apply(this, arguments);
      }
      return getTemplates;
    }()
    /**
     * Get workflow template in target project.
     *
     * @param projectId - is the project id
     * @param templateId - is the workflow template id
     * @param config -  Configurable object for overwrite request parameters.
     * @returns template.
     */
    )
  }, {
    key: "getTemplate",
    value: (function () {
      var _getTemplate = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, templateId, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/templates/").concat(templateId);
              _context2.next = 3;
              return this.HttpService.dmV2.get(url, config);
            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getTemplate(_x3, _x4, _x5) {
        return _getTemplate.apply(this, arguments);
      }
      return getTemplate;
    }()
    /**
     * Get workflows with pagination.
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F2.0/BIM360-Docs.oas2.yml?view=%2Fworkflows%2Flistworkflows
     *
     * @param projectId - is the project id
     * @param params - the query parameters. With the configurable options `offset`, `limit`, `sort`, `filter`, `folderDetails`
     * @param config -  Configurable object for overwrite request parameters.
     * @returns  array of workflow.
     */
    )
  }, {
    key: "getWorkflows",
    value: (function () {
      var _getWorkflows = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/workflows").concat(query);
              _context3.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res.data || []);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getWorkflows(_x6, _x7, _x8) {
        return _getWorkflows.apply(this, arguments);
      }
      return getWorkflows;
    }()
    /**
     * Get the workflow definition by a given workflow id.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/1d270c5984f23-get-workflow
     *
     * @param projectId - is the project id
     * @param workflowId - is the workflow id
     * @param params - is to support pagination parameters `folderDetails`
     * @param config -  Configurable object for overwrite request parameters.
     * @returns workflow.
     */
    )
  }, {
    key: "getWorkflow",
    value: (function () {
      var _getWorkflow = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, workflowId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/workflows/").concat(workflowId).concat(query);
              _context4.next = 4;
              return this.HttpService.dmV2.get(url, config);
            case 4:
              res = _context4.sent;
              return _context4.abrupt("return", res.data || {});
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getWorkflow(_x9, _x10, _x11, _x12) {
        return _getWorkflow.apply(this, arguments);
      }
      return getWorkflow;
    }()
    /**
     * Create workflow.
     *
     * @param projectId - is the project id
     * @param workflow - is the workflow boy
     *     id,
     *     name,
     *     templateId,
     *     steps,
     *     description,
     *     approvalOptions,
     *     rules,
     *     descriptiveLanguage
     * @param config -  Configurable object for overwrite request parameters.
     * @returns workflow.
     */
    )
  }, {
    key: "createWorkflow",
    value: (function () {
      var _createWorkflow = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, workflow, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/projects/".concat(projectId, "/workflows");
              _context5.next = 3;
              return this.HttpService.dmV2.post(url, workflow, config);
            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createWorkflow(_x13, _x14, _x15) {
        return _createWorkflow.apply(this, arguments);
      }
      return createWorkflow;
    }()
    /**
     * Update workflow.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/c20f34cc14fea-update-workflow
     *
     * @param projectId - is the project id
     * @param workflowId - is the workflow id
     * @param workflow - is the workflow boy
     *     id,
     *     name,
     *     templateId,
     *     steps,
     *     description,
     *     approvalOptions,
     *     rules,
     *     descriptiveLanguage
     * @param config -  Configurable object for overwrite request parameters.
     * @returns workflow.
     */
    )
  }, {
    key: "updateWorkflow",
    value: (function () {
      var _updateWorkflow = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, workflowId, workflow, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/projects/".concat(projectId, "/workflows/").concat(workflowId);
              _context6.next = 3;
              return this.HttpService.dmV2.patch(url, workflow, config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateWorkflow(_x16, _x17, _x18, _x19) {
        return _updateWorkflow.apply(this, arguments);
      }
      return updateWorkflow;
    }()
    /**
     * Delete workflows
     *
     * Currently, the batch delete only allows the deletion of inactive workflows within project templates in ACC. In the future,
     * this API can be extended to enable deletion of active workflows in normal projects and template projects.
     *
     * https://platform.stoplight.autodesk.com/docs/docs-cp/65822f3e75dad-batch-delete-workflows
     *
     * @param projectId - is the project id
     * @param workflowIds - array of workflowId
     * @param config -  Configurable object for overwrite request parameters.
     * @returns an object with shape of `results` and `errors`
     */
    )
  }, {
    key: "deleteWorkflows",
    value: (function () {
      var _deleteWorkflows = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, workflowIds, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              url = "/projects/".concat(projectId, "/workflows:batch-delete");
              _context7.next = 3;
              return this.HttpService.dmV3.post(url, workflowIds, config);
            case 3:
              res = _context7.sent;
              return _context7.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function deleteWorkflows(_x20, _x21, _x22) {
        return _deleteWorkflows.apply(this, arguments);
      }
      return deleteWorkflows;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Workflows';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Workflows;